import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {environment} from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  static createFormData(params: any): HttpParams {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        if (params[key] instanceof Array) {
          const newArray = params[key];
          for (let i = 0; i < newArray.length; i++) {
            if (typeof newArray[i] === 'object') {
              objectParse(newArray[i], key + '[' + i + ']');
            }
            if (typeof newArray[i] !== 'object') {
              httpParams = httpParams.set(
                key + '[' + i + ']',
                newArray[i]
              );
            }
          }
        } else if (typeof params[key] === 'object') {
          objectParse(params[key], key);
        } else {
          httpParams = httpParams.set(key, params[key]);
        }
      }
    }

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    function objectParse(param: any, firstkey: any) {
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          if (typeof param[key] === 'object') {
            const newObject = param[key];
            for (const newKey in newObject) {
              if (newObject.hasOwnProperty(newKey)) {
                httpParams = httpParams.set(
                  firstkey +
                  '[' +
                  key +
                  ']' +
                  '[' +
                  newKey +
                  ']',
                  newObject[newKey]
                );
              }
            }
          } else {
            httpParams = httpParams.set(
              firstkey + '[' + key + ']',
              param[key]
            );
          }
        }
      }
    }

    return httpParams;
  }

  get(url: string, option?: any): Observable<any> {
    return this.http
      .get(`${environment.apiUrl}${url}`, option)
      .pipe(catchError(this.handlerError()));
  }

  post(url: string, params: any) {
    return this.http
      .post(`${environment.apiUrl}${url}`, params)
      .pipe(catchError(this.handlerError()));
  }

  quicktogopost(url: string, params: object) {
    return this.http
      .post(`${environment.apiUrl}${url}`, params)
      .pipe(catchError(this.handlerError()));
  }


  posts(url: string) {
    return this.http
      .post(`${environment.apiUrl}${url}`, null)
      .pipe(catchError(this.handlerError()));
  }

  put(url: string, params: any) {
    return this.http
      .put(`${environment.apiUrl}${url}`, params)
      .pipe(catchError(this.handlerError()));
  }

  del(url: string) {
    return this.http
      .delete(`${environment.apiUrl}${url}`)
      .pipe(catchError(this.handlerError()));
  }

  // *** Jatak API CALLS ***
  getJatak(url: string, options?: any) {
    return this.http
      .get(`${environment.apiUrl}${url}`, options)
      .pipe(catchError(this.handlerError()));
  }

  getSpinningWheel(url: string, options?: any) {
    return this.http
      .get(`${environment.apiUrl}${url}`, options)
      .pipe(catchError(this.handlerError()));
  }

  getCampaignEmails(url: string, options?: any) {
    return this.http
      .get(`${environment.apiUrl}${url}`, options)
      .pipe(catchError(this.handlerError()));
  }

  getCard(url: string, options?: any) {
    return this.http
      .get(`${environment.apiUrl}${url}`, options)
      .pipe(catchError(this.handlerError()));
  }

  postJatak(url: string, params: any) {
    return this.http
      .post(`${environment.apiUrl}${url}`, params)
      .pipe(catchError(this.handlerError()));
  }

  // *** Facebook API CALLS ***

  //Api calling for connect modal pop
  getFacebookLoginUrl(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/facebook/login-url`)
      .pipe(
        catchError(this.handlerError())
      );
  }


  getFacebookPageList(token: string): Observable<any> {
    // eslint-disable-next-line max-len
    return this.http.get('https://graph.facebook.com/me/accounts?fields=name,username,picture.width(200),access_token&limit=50&access_token=' + token)
      .pipe(
        catchError(this.handlerError())
      );
  }


  getFacebookPagesPaginationList(url: string): Observable<any> {
    return this.http.get(url)
      .pipe(
        catchError(this.handlerError())
      );
  }

  videoUpload(videoFile: Blob, videoFormat: string) {
    const formData = new FormData();
    formData.append('video', videoFile, videoFormat)
    const url = '/upload/video'
    return this.http.post(`${environment.apiUrl}/upload/video`, formData)

  }

  // autoLogin(params:any):Observable<any>{
  //   return this.http.post(`${environment.apiUrl}/login/autologin?`, ApiService.createFormData(params) ).toPromise()
  // }



  private handlerError() {
    return (error: HttpErrorResponse): Observable<any> => throwError(error);
  }
}
